import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { FlexRow } from 'ui-components/components/flex';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import { messages } from './messages';
import styles from './styles.module.less';

/**
 * @param {object} props
 * @param {() => void} props.goToNext
 * @param {() => void} props.goToPrevious
 * @param {boolean} [props.isNextBtnDisabled]
 * @param {import('react-intl').MessageDescriptor} [props.nextBtnMessage]
 * @returns {React.JSX.Element}
 */
export const StepFooter = ({ goToNext, goToPrevious, isNextBtnDisabled = false, nextBtnMessage = messages.continue }) => {
  return (
    <FlexRow className={styles.footer}>
      <Button onClick={goToPrevious} theme={THEME_CONSTANTS.secondary}>
        <FormattedMessage {...messages.back} />
      </Button>
      <Button disabled={isNextBtnDisabled} onClick={goToNext} theme={THEME_CONSTANTS.primary}>
        <FormattedMessage {...nextBtnMessage} />
      </Button>
    </FlexRow>
  );
};
